import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Typography } from '@mui/material'

const classes = {
  rightColumn: 'right-column',
  emptyListContainer: 'empty-list-container',
}
const StyledTitleBar = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  [`& .${classes.rightColumn}`]: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default function TitleBar({ title, description, rightColumn }) {
  return (
    <StyledTitleBar>
      <div>
        <Typography variant="body1" color="textPrimary">
          <strong>{title}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </div>
      <div className={classes.rightColumn}>{rightColumn}</div>
    </StyledTitleBar>
  )
}

TitleBar.propTypes = {
  title: T.string,
  description: T.string,
  rightColumn: T.node,
}
